import React, { useEffect, useRef, useState } from "react";
import FundraisingStrategy from "../../../assets/images/icons/P-Icons/Fundraise-Icon.svg";
import CompanyDiligence from "../../../assets/images/icons/P-Icons/CompanyDilligence.svg";
import ReportonAnything from "../../../assets/images/icons/P-Icons/ReportonAnything.svg";
import MarketingStrategy from "../../../assets/images/icons/P-Icons/MarketStrategy.svg";
import CorporateVentureCapital from "../../../assets/images/icons/P-Icons/Corporate Venture Capital.svg";
import Portfolio from "../../../assets/images/icons/P-Icons/PortfolioSupport.svg";
import TechnologyRD from "../../../assets/images/icons/P-Icons/TechnologySupport.svg";
import ProductEngineering from "../../../assets/images/icons/P-Icons/Product & Engineering.svg";
import MarketingSales from "../../../assets/images/icons/P-Icons/MarketingSales.svg";
import FinanceStrategy from "../../../assets/images/icons/P-Icons/Finance & Strategy.svg";
import Legal from "../../../assets/images/icons/P-Icons/Legal.svg";
import ProfileLogo from "../../../assets/images/profileperson.svg";
import OrganizationLogo from "../../../assets/images/organization.svg";
import TeamLogo from "../../../assets/images/team.svg";
import LogoutLogo from "../../../assets/images/logout.svg";

import Org from "../../../assets/images/organization-settings.svg";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import UserIcon from "src/components/reusable/userIcon";
import { LogoutIcon } from "src/components/icons";
import { teamManagementSVG } from "src/pages/authentication/signup/_assets";
import { useNavigate } from "react-router-dom";
import { setSession } from "src/stores/session";
import { logoutUser } from "src/stores/auth";

import carbonMarkerIcon from "./landing/_assets/AgentLanding-Icons/Carbon Market Intelligence Agent.svg";
import commercializationIcon from "./landing/_assets/AgentLanding-Icons/Commercialization Strategy Agent.svg";
import emergingMarketIcon from "./landing/_assets/AgentLanding-Icons/Emerging Market Opportunity Agent.svg";
import esgTracker from "./landing/_assets/AgentLanding-Icons/ESG Compliance Tracker Agent.svg";
import financePortfolio from "./landing/_assets/AgentLanding-Icons/Financial Portfolio Optimization Agent.svg";
import ftoIcon from "./landing/_assets/AgentLanding-Icons/FTO Agent.svg";
import greenInnovation from "./landing/_assets/AgentLanding-Icons/Green Innovation Opportunity Agent.svg";
import nimbusMarketing from "./landing/_assets/AgentLanding-Icons/heroicons-outline_speakerphone.svg";
import inventionDiligence from "./landing/_assets/AgentLanding-Icons/Invention Diligence Agent.svg";
import licensingOpportunity from "./landing/_assets/AgentLanding-Icons/Licensing Opportunity Agent.svg";
import maopportunity from "./landing/_assets/AgentLanding-Icons/M&A Opportunity Mapping Agent.svg";
import operationalEfficiency from "./landing/_assets/AgentLanding-Icons/Operational Efficiency Diligence Agent.svg";
import patentLandacape from "./landing/_assets/AgentLanding-Icons/Patent Landscape Agent.svg";
import patentLicensing from "./landing/_assets/AgentLanding-Icons/Patent Licensing Agent.svg";
import paymentFraud from "./landing/_assets/AgentLanding-Icons/Payment Fraud Monitoring Agent.svg";
import priorArt from "./landing/_assets/AgentLanding-Icons/Prior Art Agent.svg";
import prosecutionHistory from "./landing/_assets/AgentLanding-Icons/Prosecution History Agent.svg";
import regulatoryImpact from "./landing/_assets/AgentLanding-Icons/Regulatory Impact Forecasting Agent.svg";
import riskHorizon from "./landing/_assets/AgentLanding-Icons/Risk Horizon Mapping Agent.svg";
import startupSpinout from "./landing/_assets/AgentLanding-Icons/Startup Spinout Support Agent.svg";
import sustainability from "./landing/_assets/AgentLanding-Icons/Sustainability Risk Assessment Agent.svg";
import technologyReadiness from "./landing/_assets/AgentLanding-Icons/Technology Readiness and Adoption Agent.svg";
import thirdPartyRisk from "./landing/_assets/AgentLanding-Icons/Third-Party Risk Monitoring Agent.svg";
import transactionalRisk from "./landing/_assets/AgentLanding-Icons/Transactional Risk Pattern Agent.svg";
import vendorPartner from "./landing/_assets/AgentLanding-Icons/Vendor and Partner Risk Assessment Agent.svg";
import vendorRisk from "./landing/_assets/AgentLanding-Icons/Vendor Risk Mapping Agent.svg";
import customer360icon from "./landing/_assets/AgentLanding-Icons/Customer360.svg";
import investmentDiligence from "./landing/_assets/AgentLanding-Icons/Investment Dilligence.svg";
import ragChatIcon from "./landing/_assets/rag_chat_icon.svg";
import MrAgent from "./landing/_assets/AgentLanding-Icons/mrpreview.png"
import EmailAgent from "./landing/_assets/AgentLanding-Icons/emailpreview.png"
import QuantAgent from "./landing/_assets/AgentLanding-Icons/quantitative_research (1).svg"
import QualAgent from "./landing/_assets/AgentLanding-Icons/reliability.svg"
import whitepaperLogo from "../../../assets/images/Whitepaper agent.svg"
import { Megaphone } from "lucide-react";

interface Props {
  agentName?: string;
  hideMenu?: boolean;
  className?: string;
}

const agentIcons: Record<string, string> = {
  "Company Diligence Agent": CompanyDiligence,
  "Company Diligence Agent Sample Chat": CompanyDiligence,
  "Fundraising Strategy Agent": FundraisingStrategy,
  "Fundraising Strategy Agent Sample Chat": FundraisingStrategy,
  "Report on Anything Agent": ReportonAnything,
  "Report on Anything Agent Sample Chat": ReportonAnything,
  "Market Strategy Agent": MarketingStrategy,
  "Market Strategy Agent Sample Chat": MarketingStrategy,
  "Corporate Venture Capital Agent": CorporateVentureCapital,
  "Corporate Venture Capital Agent Sample Chat": CorporateVentureCapital,
  "Portfolio Support Agent": Portfolio,
  "Portfolio Support Agent Sample Chat": Portfolio,
  "Technology & R&D Agent": TechnologyRD,
  "Technology & R&D Agent Sample Chat": TechnologyRD,
  "Product & Engineering Agent": ProductEngineering,
  "Product & Engineering Agent Sample Chat": ProductEngineering,
  "Finance & Strategy Agent": FinanceStrategy,
  "Finance & Strategy Agent Sample Chat": FinanceStrategy,
  "Marketing & Sales Agent": MarketingSales,
  "Marketing & Sales Agent Sample Chat": MarketingSales,
  "Legal & Compliance Agent": Legal,
  "Legal & Compliance Agent Sample Chat": Legal,

  "Risk Horizon Mapping Agent": riskHorizon,
  "Financial Portfolio Optimization Agent": financePortfolio,
  "Regulatory Impact Forecasting Agent": regulatoryImpact,
  "Emerging Market Opportunity Agent": emergingMarketIcon,
  "Vendor and Partner Risk Assessment Agent": vendorPartner,
  "M&A Opportunity Mapping Agent": maopportunity,
  "Payment Fraud Monitoring Agent": paymentFraud,
  "Transactional Risk Pattern Agent": transactionalRisk,
  "Invention Diligence Agent": inventionDiligence,
  "Commercialization Strategy Agent": commercializationIcon,
  "Licensing Opportunity Agent": licensingOpportunity,
  "Startup Spinout Support Agent": startupSpinout,
  "Technology Readiness and Adoption Agent": technologyReadiness,
  "ESG Compliance Tracker Agent": esgTracker,
  "Sustainability Risk Assessment Agent": sustainability,
  "Green Innovation Opportunity Agent": greenInnovation,
  "Carbon Market Intelligence Agent": carbonMarkerIcon,
  "Vendor Risk Mapping Agent": vendorRisk,
  "Operational Efficiency Diligence Agent": operationalEfficiency,
  "Third-Party Risk Monitoring Agent": thirdPartyRisk,
  "Customer 360 Agent": customer360icon,
  "Investment Diligence Agent": investmentDiligence,
  "Marketing Agent": nimbusMarketing,
  "MR Insights Agent": MrAgent,
  "Email Automation Agent": EmailAgent,
  "Qualitative Agent - V2": QualAgent,
  "Qualitative Agent - V3": QualAgent,
  "Quantitative Agent": QuantAgent,
  "Prior Art Agent": priorArt,
  "FTO Agent": ftoIcon,
  "Patent Licensing Agent": patentLicensing,
  "Patent Landscape Agent": patentLandacape,
  "Prosecution History Agent": prosecutionHistory,
  "Rag Chatbot": ragChatIcon,
  "Report Anything Agent":ReportonAnything,
  "Whitepaper Generation Agent":whitepaperLogo,
};

const AgentHead = (props: Props) => {
  const { className } = props;
  const { agentName = "", hideMenu } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const userDetail = useAppSelector((state) => state.auth.user);

  const [open, setOpen] = useState(false);
  const menuRef = useRef<any>(null);

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    dispatch(setSession({ session_data: {} }));

    await dispatch(logoutUser());
    navigate("/login");
    setIsLoggingOut(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (menuRef.current && !menuRef.current?.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const iconSrc = agentIcons[agentName] || "/icons/default-agent.png";


  const displayName =
    agentName === "Startup Diligence Agent" ? "Company Diligence Agent" : agentName;

  return (
    <div className={`flex items-center justify-between mt-2 mb-2 rounded-lg ${className ?? ''}`}>
      {/* Left Section: Icon and Name */}
      <div className="flex items-center gap-1">
        <div className="text-white flex items-center justify-center rounded-full w-4 h-4">
          {agentName && (
            <div
              className="rounded-full w-full h-full flex items-center justify-center"
            // style={{
            //   background: "rgb(68, 40, 115)",
            // }}
            >
              {agentIcons[agentName] ? (
                <img
                  src={iconSrc}
                  alt={displayName}
                  className={`${(agentName === "MR Insights Agent" || agentName === "Email Automation Agent" || agentName === "Qualitative Agent - V2" || agentName === "Qualitative Agent - V3") ? "w-3 h-3" : "w-4 h-4"} `}
                // style={{
                //   filter:
                //     "invert(100%) sepia(0%) saturate(2%) hue-rotate(270deg) brightness(109%) contrast(101%)",
                // }}
                />
              ) : null}
            </div>
          )}
        </div>
        <h1 className="text-base text-gray-800">{displayName}</h1>
      </div>

      {/* Right Section: Profile Image */}
      {hideMenu ? null : (
        <div
          className="relative joy-profile"
          onClick={() => setOpen((prev) => !prev)}
          ref={menuRef}
        >
          <UserIcon
            first_name={userDetail?.first_name || ""}
            last_name={userDetail?.last_name || ""}
            profile_photo={userDetail?.profile_photo}
          />
          {open && (
            <div className="absolute right-0 mt-2 w-[210px] bg-white rounded-lg shadow-lg border z-[1]">
              <ul className="">
                <li
                  className="flex items-center  p-2 hover:bg-gray-100 rounded cursor-pointer"
                  onClick={() => navigate("/profile")}
                >
                  {/* <FiUser className="text-gray-600" /> */}
                  <img src={ProfileLogo} />
                  <span>My profile</span>
                </li>
                <li
                  className="flex items-center  p-2 hover:bg-gray-100 rounded cursor-pointer"
                  onClick={() => navigate("/users")}
                >
                  {/* <BsBuilding className="text-gray-600" /> */}
                  <img src={OrganizationLogo} />
                  <span>Organization</span>
                </li>
                <li
                  className="flex items-center  p-2 hover:bg-gray-100 rounded cursor-pointer"
                  onClick={() => navigate("/users")}
                >
                  {/* <FiUsers className="text-gray-600" /> */}
                  <img src={TeamLogo} />
                  <span>Team</span>
                </li>
                <hr />
                <li
                  className="flex items-center gap-1  p-2 hover:bg-gray-100 rounded cursor-pointer text-black ml-[2px]"
                  onClick={handleLogout}
                >
                  {/* <FiLogOut /> */}
                  {/* <LogoutIcon /> */}
                  <img src={LogoutLogo} />
                  <span>Log out</span>
                </li>
              </ul>
            </div>
          )}
          {/* <img
          src="https://via.placeholder.com/40"
          alt="Profile"
          className="w-10 h-10 rounded-full object-cover"
        /> */}
        </div>
      )}
    </div>
  );
};

export default AgentHead;
